import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      fontSize: '16px',
      fontWeight: 500,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    text: {
      margin: 0,
      '&:nth-child(1)': {
        marginBottom: '8px'
      }
    },
    price: {
      fontSize: '20px',
      fontWeight: 600
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
